import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';
import { prismicRichText } from '@styles/utils';

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: row;
  ${media.smallScreen`
    display: block;
  `}
  ${prismicRichText}
`;

export const Photo = styled.div<{ count: number }>`
  width: ${({ count }) => `calc(100% / ${count})`};
  padding-left: 1rem;
  padding-right: 1rem;

  ${media.smallScreen`
    width: 100%;
    padding-right: 0;
    padding-left: 0;
    padding-top: 1rem;
    padding-botton: 1rem;
  `}
`;
